const COMPONENT_NAME = "DELIVERY_LOCATION_DRAWER";
const FORM_COMPONENT_NAME = "DELIVERY_LOCATION_DRAWER_FORM";
const FORM_INPUT_COMPONENT_NAME = "DELIVERY_LOCATION_DRAWER_FORM_INPUT";
const FORM_SUBMIT_BUTTON_COMPONENT_NAME = "DELIVERY_LOCATION_DRAWER_FORM_SUBMIT_BUTTON";
const countryCodeMap = {
  "en-us": "US",
  "en-ca": "CA",
  "fr-ca": "CA"
};
export {
  COMPONENT_NAME,
  FORM_COMPONENT_NAME,
  FORM_INPUT_COMPONENT_NAME,
  FORM_SUBMIT_BUTTON_COMPONENT_NAME,
  countryCodeMap
};
